import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import WarningIcon from "@/assets/images/warning.png";
import { Button, Container, Typography } from "@/components/atoms";
import { GeneralFooter, GeneralHeader } from "@/components/organisms";
import { useAppResetApi } from "@/redux/hooks";

export const RegistrationError = () => {
  const resetApi = useAppResetApi();
  const { logout } = useKindeAuth();

  const handleLogout = () => {
    resetApi();
    logout();
  };

  return (
    <div className="flex min-h-screen flex-row overflow-hidden">
      <div className="relative flex flex-1 flex-col">
        <GeneralHeader />
        <div className="flex flex-1 flex-row bg-contain bg-[center_bottom_-2rem] bg-no-repeat">
          <Container className="flex max-w-md flex-col items-center px-5 pb-32 pt-[14vh]">
            <img src={WarningIcon} alt="Registration Error" className="max-w-[128px]" />
            <Typography variant="title" className="mb-4 text-center !text-[24px] sm:!text-[32px]">
              Something went wrong
            </Typography>
            <Typography variant="paragraph" className="mb-2 text-center text-neutral-dark-gray">
              We couldn&apos;t determine your account type during registration. This can happen if there was a connection
              issue or if the signup link was incomplete.
            </Typography>
            <Typography variant="paragraph" className="text-center text-neutral-dark-gray">
              If the issue persists, contact support@rideminder.com for help.
            </Typography>
            <Button onClick={handleLogout} className="mt-8" size="lg">
              Try Again
            </Button>
          </Container>
          <div className="pointer-events-none fixed bottom-0 min-h-[50%] w-full bg-city bg-cover bg-no-repeat" />
        </div>
        <GeneralFooter />
      </div>
    </div>
  );
};
